import { render, staticRenderFns } from "./DataTablePerPage.vue?vue&type=template&id=123a7c65&scoped=true&"
import script from "./DataTablePerPage.vue?vue&type=script&lang=js&"
export * from "./DataTablePerPage.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePerPage.vue?vue&type=style&index=0&id=123a7c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a7c65",
  null
  
)

export default component.exports